export default __webpack_public_path__ + "static/media/MCD_Gob_harddiskmuseum_white.8bf912bc.svg";